export const listaPackagings = [
  {
    id: "000001",
    codigoAS400: "PKG001",
    nombreComercial: "Saco 25kg Bio",
    descripcion: "Envase reciclable para fertilizante sólido.",
    medidas: { alto: 80, ancho: 40, largo: 10, desarrollo: 60 },
    tipo: "Saco",
    formato: "Sólido",
    material: "Polipropileno",
    color: "Verde oscuro",
    proveedor: "Macresac",
  },
  {
    id: "000002",
    codigoAS400: "PKG002",
    nombreComercial: "Garrafa 5L",
    descripcion: "Contenedor rígido para bioestimulante líquido.",
    medidas: { alto: 25, ancho: 15, largo: 10, desarrollo: null },
    tipo: "Garrafa",
    formato: "Líquido",
    material: "HDPE",
    color: "Blanco",
    proveedor: "Rodenas",
  },
  {
    id: "000003",
    codigoAS400: "PKG003",
    nombreComercial: "Botella 1L",
    descripcion: "Botella plástica para líquidos concentrados.",
    medidas: { alto: 20, ancho: 7, largo: 7, desarrollo: null },
    tipo: "Botella",
    formato: "Líquido",
    material: "PET",
    color: "Transparente",
  },
  {
    id: "000004",
    codigoAS400: "PKG004",
    nombreComercial: "Caja cartón mediana",
    descripcion: "Caja de cartón para embalaje múltiple.",
    medidas: { alto: 30, ancho: 40, largo: 50, desarrollo: null },
    tipo: "Caja",
    formato: "Sólido",
    material: "Cartón reciclado",
    color: "Marrón",
  },
  {
    id: "000005",
    codigoAS400: "PKG005",
    nombreComercial: "Bidón 10L",
    descripcion: "Bidón resistente para líquidos industriales.",
    medidas: { alto: 40, ancho: 25, largo: 25, desarrollo: null },
    tipo: "Bidón",
    formato: "Líquido",
    material: "HDPE",
    color: "Azul",
  },
  {
    id: "000006",
    codigoAS400: "PKG006",
    nombreComercial: "Saco 50kg",
    descripcion: "Saco reforzado para fertilizantes sólidos.",
    medidas: { alto: 90, ancho: 50, largo: 12, desarrollo: 70 },
    tipo: "Saco",
    formato: "Sólido",
    material: "Polipropileno",
    color: "Blanco",
  },
  {
    id: "000007",
    codigoAS400: "PKG007",
    nombreComercial: "Tubo dosificador",
    descripcion: "Tubo plástico para dosificación precisa.",
    medidas: { alto: 15, ancho: 3, largo: 3, desarrollo: null },
    tipo: "Tubo",
    formato: "Líquido",
    material: "PVC",
    color: "Transparente",
  }
];

